import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import { DialogContent, DialogTitle } from 'components/common/DialogApi'

import useStyles from './EditUserStyles'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import Autocomplete from '@mui/lab//Autocomplete'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import MenuItem from '@mui/material/MenuItem'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import userActions from 'pages/User/actions'
import { useSelector } from 'react-redux'
import { UserRole, UserRoleText, USER_PROP } from '../constants'
import {
    DialogActions,
    FormControl,
    Grid,
    Typography,
    useMediaQuery,
    Checkbox,
} from '@mui/material'
import { checkEmailValid, checkFieldValid } from '../Validation'
import Transition from 'components/common/Transition'
import PasswordField from 'components/common/PasswordField'
import { GROUP_PROP } from 'pages/Groups/constants'

const EditUserContainer = () => {
    const styles = useStyles()
    const { editUser, isEditDialogOpen, existingGroups } = useSelector(
        (state) => state.user,
    )
    const { updateUser, closeEditDialog, setEditUser } = userActions()
    const [currentUser, setUser] = useState({
        [USER_PROP.EMAIL]: '',
        [USER_PROP.FNAME]: '',
        [USER_PROP.LNAME]: '',
        [USER_PROP.ROLE]: UserRole.USER,
        [USER_PROP.PASSWORD]: '',
        [USER_PROP.TITLE]: '',
        [USER_PROP.AFFILIATION]: '',
    })
    const [isFormValid, setIsFormValid] = useState(true)
    const [editPassword, setEditPassword] = useState(false)

    useEffect(() => {
        setUser({ ...editUser, password: '' })
    }, [editUser])

    const submitForm = (event) => {
        event.preventDefault()
        updateUser(currentUser.id, currentUser, onCloseDialog)
    }
    const onCloseDialog = () => {
        setEditPassword(false)
        closeEditDialog()
    }
    useEffect(() => {
        checkFormValidity()
    })

    const labels = {
        [USER_PROP.EMAIL]: 'Email',
        [USER_PROP.FNAME]: 'First Name',
        [USER_PROP.LNAME]: 'Last Name',
        [USER_PROP.PASSWORD]: 'Password',
        [USER_PROP.ROLE]: 'Role',
        [USER_PROP.TITLE]: 'Title',
        [USER_PROP.AFFILIATION]: 'Affiliation',
    }
    const checkFormValidity = () => {
        let checkFields =
            checkEmailValid(currentUser[USER_PROP.EMAIL]) &&
            !!currentUser[USER_PROP.FNAME] &&
            !!currentUser[USER_PROP.LNAME]
        if (editPassword) {
            checkFields = checkFields && !!currentUser[USER_PROP.PASSWORD]
        }
        setIsFormValid(checkFields)
    }
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'))
    return (
        <Dialog
            fullScreen={!matches}
            TransitionComponent={Transition}
            fullWidth
            disableBackdropClick
            open={isEditDialogOpen}
            onClose={onCloseDialog}
        >
            <DialogTitle onClose={onCloseDialog}>
                <Grid container justify="center">
                    <Typography variant="h6"> Edit user</Typography>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <div className={styles.content} onSubmit={submitForm}>
                    <form noValidate style={{ display: 'grid', gridGap: '1.25rem' }}>
                        {[
                            USER_PROP.EMAIL,
                            USER_PROP.FNAME,
                            USER_PROP.LNAME,
                            USER_PROP.TITLE,
                            USER_PROP.AFFILIATION
                        ].map((value) => {
                            return (
                                <TextField
                                    error={
                                        !checkFieldValid(
                                            value,
                                            currentUser[value],
                                        )
                                    }
                                    variant="outlined"
                                    required
                                    fullWidth
                                    key={value}
                                    label={labels[value]}
                                    name={value}
                                    autoComplete={value}
                                    value={currentUser[value]}
                                    onChange={(e) => {
                                        setUser({
                                            ...currentUser,
                                            [value]: e.target.value,
                                        })
                                    }}
                                />
                            )
                        })}
                        <FormControl
                            className={styles.roleControl}
                            fullWidth
                            variant="outlined"
                        >
                            <InputLabel id="demo-simple-select-label">
                                Role
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                required
                                label={labels[USER_PROP.ROLE]}
                                onChange={(e) =>
                                    setUser({
                                        ...currentUser,
                                        [USER_PROP.ROLE]: e.target.value,
                                    })
                                }
                                value={currentUser[USER_PROP.ROLE]}
                            >
                                {Object.keys(UserRole).map((x) => {
                                    return (
                                        <MenuItem value={UserRole[x]} key={x}>
                                            {UserRoleText[x]}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>

                        <FormGroup row>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={editPassword}
                                        onChange={(e) => {
                                            setEditPassword(e.target.checked)
                                            setUser({
                                                ...currentUser,
                                                [USER_PROP.PASSWORD]: '',
                                            })
                                        }}
                                        name="Edit password"
                                    />
                                }
                                label="Change password"
                            />

                            {editPassword && (
                                <PasswordField
                                    variant="outlined"
                                    error={
                                        !checkFieldValid(
                                            USER_PROP.PASSWORD,
                                            currentUser[USER_PROP.PASSWORD],
                                        )
                                    }
                                    required
                                    fullWidth
                                    label="New Password"
                                    name="password"
                                    autoComplete="password"
                                    type="password"
                                    value={
                                        currentUser[USER_PROP.PASSWORD] || ''
                                    }
                                    onChange={(e) => {
                                        setUser({
                                            ...currentUser,
                                            [USER_PROP.PASSWORD]:
                                                e.target.value,
                                        })
                                    }}
                                />
                            )}
                        </FormGroup>
                    </form>
                </div>
                <DialogActions>
                    <Button
                        type="submit"
                        fullWidth={!matches}
                        disabled={!isFormValid}
                        variant="contained"
                        color="primary"
                        onClick={submitForm}
                    >
                        Save
                    </Button>
                    <Button
                        fullWidth={!matches}
                        onClick={onCloseDialog}
                        variant="contained"
                        color="secondary"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}

export default EditUserContainer
